// extracted by mini-css-extract-plugin
module.exports = {"sectorWithSticky":"_02712f2b3b--sectorWithSticky--E1hlm","nav-container":"_02712f2b3b--nav-container--AcKLB _02712f2b3b--sectorWithSticky--E1hlm"};